import {
  useAuthStore,
  useConfigStore,
  useTransactionStore,
  useUsersStore,
} from "@/stores";
import { createRouter, createWebHistory } from "vue-router";
import { nextTick } from "vue";
import { ReservationSource, userRoles } from "@/helpers/types";

const useOldForm = import.meta.env.VITE_APP_USE_OLD_FORM === "true";

const formComponent = useOldForm
  ? () => import("../views/public/OldForm.vue")
  : () => import("../views/public/form/Form.vue");

function isContactSubdomain() {
  return typeof window !== 'undefined' && 
         (window.location.hostname === 'cadastro.selfiecheckin.com.br' || window.location.hostname === 'cadastro.selfiecheckin.com' || window.location.hostname === 'cadastro.localhost');
}

const contactSubdomainRoutes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/NewContact.vue"),
    meta: {
      publicPage: true,
    },
  },
];



const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: !isContactSubdomain() ? [
    {
      path: "/",
      name: "home",
      component: () => import("../views/Home.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/sobre-nos",
      name: "About",
      component: () => import("../views/About.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/planos",
      name: "Plans",
      component: () => import("../views/Plans.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/contato",
      name: "Contact",
      component: () => import("../views/Contact.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/Login.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/register",
      name: "register",
      component: () => import("../views/Register.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/wait-contact",
      name: "waitContact",
      component: () => import("../views/WaitContact.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/recover",
      name: "recover",
      component: () => import("../views/RecoverPassword.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/use-terms-pt",
      name: "formdata_source_details_terms_of_use_pt",
      component: () => import("../views/public/TermsOfUsePt.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/use-terms/:locale?",
      name: "formdata_source_details_terms_of_use",
      component: () => import("../views/public/terms/TermsOfUse.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/image-terms/:locale?",
      name: "formdata_source_details_image_terms",
      component: () => import("../views/public/terms/ImageTerms.vue"),
      meta: {
        publicPage: true,
      },
    },
    // a Política de Privacidade foi substituída pelos Termos de Uso da Imagem;
    // links antigos continuam funcionando
    {
      path: "/privacy-policy/:locale?",
      redirect: (to) => `/image-terms/${to.params.locale || ""}`,
    },
    {
      path: "/privacy-policy-pt",
      redirect: "/image-terms/pt",
    },
    {
      path: "/p/form/details/:source/:id",
      name: "form_source_details",
      component: () => import("../views/public/Details.vue"),
      meta: {
        publicPage: true,
      },
    },

    {
      path: "/p/formdata/details/:friendlyCode/:source/:id",
      name: "formdata_source_details",
      component: () => import("../views/public/Details.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/p/formdata/generic/:friendlyCode/:residenceId/:source",
      name: "formdata_source_unique_link",
      component: formComponent,
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/process-notification/:token",
      name: "process_notification",
      component: () => import("../views/public/ProcessNotification.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/u/houses/details",
      name: "form_source_houseDetails",
      props: route => ({
        isPreview: route.query.isPreview === "true",
        house: typeof route.query.house === 'string' ? JSON.parse(route.query.house) : null,
      }),
      component: () => import("../views/public/DetailsPreview.vue"),
    },
    {
      path: "/u/houses/details/:token",
      name: "form_source_residence_preview",
      component: () => import("../views/public/DetailsPreview.vue"),
      meta: {
        publicPage: true,
      },
    },
    // ...Array.from(Object.values(ReservationSource)).map((rs) => {
    //   return {
    //     path: `/p/form/${rs}/:id/:additionalId?`,
    //     name: `form_source_${rs}`,
    //     component: () => import("../views/public/OldForm.vue"),
    //     meta: {
    //       source: rs,
    //       publicPage: true,
    //     },
    //   };
    // }),
    ...Array.from(Object.values(ReservationSource)).map((rs) => {
      return {
        path: `/p/formdata/:friendlyCode/${rs}/:id/:additionalGuestKey?`,
        name: `formdata_source_${rs}`,
        component: formComponent,
        meta: {
          source: rs,
          publicPage: true,
        },
      };
    }),
    {
      path: "/admin/users",
      name: "userList",
      component: () => import("../views/admin/ListUsers.vue"),
    },
    {
      path: "/admin/price-tables",
      name: "priceTables",
      component: () => import("../views/admin/ListPriceTables.vue"),
    },
    {
      path: "/u",
      name: "user",
      component: () => import("../components/partials/UserLayout.vue"),
      children: [
        {
          path: "/u/home",
          name: "userHome",
          component: () => import("../views/user/Home.vue"),
        },
        {
          path: "/u/reserves",
          name: "checkinLists",
          component: () => import("../views/user/ListBooking.vue"),
        },
        {
          path: "/u/reserves-historic",
          name: "Historic",
          component: () => import("../views/user/ListBookingHistoric.vue"),
        },
        {
          path: "/u/videos",
          name: "Videos",
          component: () => import("../views/user/Videos.vue"),
        },
        {
          path: "/u/config",
          name: "Configs",
          component: () => import("../views/user/Configs.vue"),
        },
        {
          path: "/u/subscription",
          name: "Subscription",
          component: () => import("../views/user/Subscription.vue"),
        },
        {
          path: "/u/houses",
          name: "Houses",
          component: () => import("../views/user/Houses.vue"),
        },
        {
          path: "/u/models",
          name: "Models",
          component: () => import("../views/user/Models.vue"),
        },
        {
          path: "/u/perfil",
          name: "Perfil",
          component: () => import("../views/user/Perfil.vue"),
        },
        {
          path: "/u/users",
          name: "Users",
          component: () => import("../views/user/Users.vue"),
        },
        {
          path: "/u/users/performance",
          name: "UsersPerformance",
          component: () => import("../views/user/UsersPerformance.vue"),
        },

        {
          path: "/u/guest/:id",
          name: "guestDetails",
          component: () => import("../views/user/GuestDetails.vue"),
        },
        {
          path: "/u/keys/config",
          name: "KeyConfig",
          component: () => import("../views/user/KeyConfig.vue"),
        },
      ],
    },
  ] : contactSubdomainRoutes,
  scrollBehavior(to, from, savedPosition) {
    return { left: 0, top: 0, behavior: "smooth" };
  },
});

router.beforeEach(async (to, from, next) => {

  const authRequired = to?.meta?.publicPage != true;
  const sendToNewPainel = authRequired;
  if (sendToNewPainel) {
    window.location.href = import.meta.env.VITE_APP_LOGIN_URL;
    next(false);
    return;
  }
  next();
});

export default router;
